const YOUTUBE_VIDEO_ID_LENGTH = 11;
const YOUTUBE_VIDEO_ID_REGEX = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|shorts\/)([^#&?]*).*/;

export const getVideoIdFromUrl = (url: string): string | undefined => {
  const regexMatched = url.match(YOUTUBE_VIDEO_ID_REGEX);
  return regexMatched?.[1]?.length === YOUTUBE_VIDEO_ID_LENGTH ? regexMatched?.[1] : undefined;
};